// ----------------------------------------------------------------------

export const PATH = {
  website: 'https://sowan.sa/',
  root: '/',
  overview: '/overview',
  invoice: {
    root: '/invoice',
    sale: {
      root: '/invoice/sale',
      new: '/invoice/sale/new',
      view: '/invoice/sale/',
    },
    purchase: {
      root: '/invoice/purchase',
      new: '/invoice/purchase/new',
      view: '/invoice/purchase/',
    },
    note: {
      root: '/invoice/note',
      // new: '/invoice/note/new',
      view: '/invoice/note/',
    },
    prepayment: {
      root: '/invoice/prepayment',
      new: '/invoice/prepayment/new',
      view: '/invoice/prepayment/',
    },
    expense: {
      root: '/invoice/expense',
      new: '/invoice/expense/new',
      view: '/invoice/expense/',
    },
    payment: {
      root: '/invoice/payment',
      view: '/invoice/payment/',
    },
  },
  accounting: {
    root: '/accounting',
    account: {
      root: '/accounting/account',
      new: '/accounting/account/new',
      view: '/accounting/account/',
    },
    trialBalance: {
      root: '/accounting/trialBalance',
    },
    profitLoss: {
      root: '/accounting/profitLoss',
      detailed: '/accounting/profitLossDetailed',
    },
    balanceSheet: {
      root: '/accounting/balanceSheet',
      // detailed: '/accounting/balanceSheetDetailed',
    },
    journal: {
      root: '/accounting/journal',
      new: '/accounting/journal/new',
      view: '/accounting/journal/',
    },
    journalEntry: {
      root: '/accounting/journalEntry',
      new: '/accounting/journalEntry/new',
      view: '/accounting/journalEntry/',
    },
    accountSettings: {
      root: '/accounting/accountSettings',
    },
  },
  stock: {
    root: '/stock',
    transfer: {
      root: '/stock/transfer',
      new: '/stock/transfer/new',
      view: '/stock/transfer/',
    },
    adjustment: {
      root: '/stock/adjustment',
      new: '/stock/adjustment/new',
      view: '/stock/adjustment/',
    },
    transaction: {
      root: '/stock/transaction',
    },
  },
  customer: {
    root: '/customer',
    view: '/customer/',
  },
  supplier: {
    root: '/supplier',
    view: '/supplier/',
  },
  product: {
    root: '/product',
    new: '/product/new',
    view: '/product/',
  },
  categoryProduct: {
    root: '/category-product',
    view: '/category-product/',
  },
  project: {
    root: '/project/board',
  },
  report: {
    root: '/report',
    sale: '/report/sale',
    purchase: '/report/purchase',
    expense: '/report/expense',
    tax: '/report/tax',
    stock: '/report/stock',
    profitLoss: '/report/profit-loss',
    dispatch: '/report/dispatch',
  },
  management: {
    settings: {
      root: '/management/settings',
      general: '/management/settings?tab=general',
      subscription: '/management/settings?tab=subscription',
      profile: '/management/settings?tab=profile',
      change_password: '/management/settings?tab=change_password',
    },
    subscription: {
      root: '/management/subscription',
      suspend: '/management/subscription/suspend',
      new: '/management/subscription/new',
      success: '/management/subscription/success',
      invoice: '/management/subscription/invoice/',
    },
    member: {
      root: '/management/member',
      view: '/management/member/',
    },
    branch: {
      root: '/management/branch',
      view: '/management/branch/',
    },
    team: {
      root: '/management/team',
      view: '/management/team/',
    },
    paymentMethod: {
      root: '/management/payment-method',
      view: '/management/payment-method/',
    },
    historyLog: '/management/history-log',
  },
  auth: {
    login: '/login',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password/',
    setPassword: '/set-password/',
    invitation: '/invitation/',
    activation: '/activation',
    register: '/register',
    sso: '/sso',
    PaymentCard: '/payment-card',
  },
  misc: {
    suspend: '/suspend',
    page403: '/403',
    page404: '/404',
    upgrade: '/upgrade',
  },
  hr: {
    root: '/hr',
    dashboard: '/hr/dashboard',
    holiday: {
      root: '/hr/holiday',
      new: '/hr/holiday/new',
      view: '/hr/holiday/',
    },
    department: {
      root: '/hr/department',
      new: '/hr/department/new',
      view: '/hr/department/',
    },
    employee: {
      root: '/hr/employee',
      new: '/hr/employee/new',
      view: '/hr/employee/',
    },
    vacation: {
      root: '/hr/vacation',
      new: '/hr/vacation/new',
      view: '/hr/vacation/',
    },
    vacationType: {
      root: '/hr/vacation-type',
      new: '/hr/vacation-type/new',
      view: '/hr/vacation-type/',
    },
    vacationPolicy: {
      root: '/hr/vacation-policy',
      new: '/hr/vacation-policy/new',
      view: '/hr/vacation-policy/',
    },
    payroll: {
      root: '/hr/payroll',
      new: '/hr/payroll/new',
      view: '/hr/payroll/',
    },
    attendance: {
      root: '/hr/attendance',
      bulk: '/hr/attendance/bulk',
      view: '/hr/attendance/',
      settings: '/hr/attendance/settings',
      daily: '/hr/attendance/daily',
      monthly: '/hr/attendance/monthly',
    },
  },
  portal: {
    overview: '/portal/overview',
    profile: '/portal/profile',
    vacations: '/portal/vacations',
    vacationRequest: '/portal/vacations/request',
    vacationView: '/portal/vacations/',
    attendance: '/portal/attendance',
    attendanceView: '/portal/attendance/',
  },
  external: {
    terms: 'https://sowan.sa/terms-and-conditions-ar',
    privacy: 'https://sowan.sa/privacy-policy-ar',
    calendly: 'https://calendly.com/sowan/tour',
    apps: {
      main: {
        ios: 'https://apps.apple.com/us/app/%D8%B5-%D9%88%D8%A7%D9%86/id1623771749',
        android: 'https://play.google.com/store/apps/details?id=com.tafeal.sowan',
      },
      pos: {
        windows: 'https://sowan-space.fra1.digitaloceanspaces.com/application/latest.exe',
        ios: 'https://apps.apple.com/us/app/%D9%83%D8%A7%D8%B4%D9%8A%D8%B1-%D8%B5-%D9%88%D8%A7%D9%86/id1628808144',
        android: 'https://play.google.com/store/apps/details?id=com.tafeal.sowanpos',
      },
    },
  },
};
